import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
  Box,
  Stack,
  Typography,
  IconButton,
  alpha,
} from "@mui/material";
import {
  Warning as WarningIcon,
  Save as SaveIcon,
  Cancel as CancelIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import CustomInput from "../../../CustomForm/CustomInput";

const RiskTypeDialog = ({
  open,
  onClose,
  formData,
  setFormData,
  onSubmit,
  isLoading,
  editingRiskType,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ sx: { borderRadius: "12px", overflow: "hidden" } }}
    >
      {/* HEADER */}
      <Box
        sx={{
          px: 2.5,
          py: 1.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          bgcolor: "#F8FAFC",
          borderBottom: "1px solid #E2E8F0",
        }}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: "8px",
              bgcolor: alpha("#F59E0B", 0.08),
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <WarningIcon sx={{ color: "#F59E0B", fontSize: 18 }} />
          </Box>
          <Box>
            <Typography variant="subtitle1" fontWeight={600} color="#1A1A2E">
              {editingRiskType ? "Edit Risk Type" : "Create Risk Type"}
            </Typography>
            <Typography
              variant="caption"
              color="#64748b"
              sx={{ fontSize: "0.7rem" }}
            >
              {editingRiskType
                ? "Update the risk type details"
                : "Create a new risk type"}
            </Typography>
          </Box>
        </Stack>
        <IconButton
          size="small"
          onClick={onClose}
          sx={{ color: "#94A3B8", p: 0.5 }}
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Box>

      {/* CONTENT */}
      <DialogContent sx={{ pt: 3, px: 2.5 }}>
        <CustomInput
          label="Risk Type Name *"
          placeholder="Enter risk type name"
          fullWidth
          size="medium"
          required
          autoFocus
          value={formData.name}
          onChange={(e) => setFormData({ name: e.target.value })}
        />
      </DialogContent>

      {/* ACTIONS */}
      <DialogActions sx={{ borderTop: "1px solid #E2E8F0", p: 2, gap: 1 }}>
        <Button
          variant="outlined"
          onClick={onClose}
          disabled={isLoading}
          startIcon={<CancelIcon sx={{ fontSize: 18 }} />}
          size="small"
          sx={{
            textTransform: "none",
            fontWeight: 500,
            borderRadius: "6px",
            borderColor: "#D0D5DD",
            color: "#344054",
            px: 3,
            py: 0.75,
            "&:hover": { bgcolor: "#F9FAFB", borderColor: "#98A2B3" },
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onSubmit}
          disabled={isLoading || !formData.name?.trim()}
          startIcon={
            isLoading ? (
              <CircularProgress size={18} color="inherit" />
            ) : (
              <SaveIcon sx={{ fontSize: 18 }} />
            )
          }
          size="small"
          sx={{
            textTransform: "none",
            fontWeight: 600,
            borderRadius: "6px",
            bgcolor: "#2469F0",
            px: 3,
            py: 0.75,
            "&:hover": {
              bgcolor: "#1A5BD4",
              boxShadow: "0px 2px 8px rgba(36, 105, 240, 0.3)",
            },
            "&.Mui-disabled": { bgcolor: "#F1F5F9", color: "#94A3B8" },
          }}
        >
          {editingRiskType ? "Update" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RiskTypeDialog;